import {Decimal} from 'decimal.js';

import {MoneySchema} from './Money';
import {BigDecimalSchema} from './Price';

// Rates and amounts that are non-negative quantities by contract. The wire types are a bare
// decimal string and a `Money`, so the constraint has to be spelled out here.
export const NonNegativeBigDecimalSchema = BigDecimalSchema.refine((value) => {
  try {
    const decimal = new Decimal(value);

    return decimal.isFinite() && !decimal.isNegative();
  } catch {
    return false;
  }
}, 'Value must be a finite non-negative decimal');

export const NonNegativeMoneySchema = MoneySchema.extend({
  amount: NonNegativeBigDecimalSchema,
});
